import React from 'react';

import classNames from 'classnames';
import AttachmentIcon from 'icons/attachment.svg';
import PropTypes from 'prop-types';

import TrainingRowBookingPill from 'components/mobileTrainingProfile/components/homeScreen/TrainingRowBookingPill';
import TrainingStatus from 'components/training/TrainingStatus';

import { getTrainingStatus } from 'components/helpers/resources/training';
import { resourceShape } from 'components/helpers/serialisableResources';

export default function TrainingRow({
  attachments,
  booking,
  course,
  isRequired,
  latestTraining,
  onViewCourseDetailsClick,
  registration,
  requiredSource,
}) {
  const currentTrainingStatus = getTrainingStatus({
    course,
    training: latestTraining,
  });

  const handleRowClick = () => {
    onViewCourseDetailsClick({ id: course.id, isRequired });
  };

  return (
    <tr
      className='tw-h-[49px] tw-cursor-pointer hover:tw-bg-grey-025'
      onClick={handleRowClick}
    >
      <td className='tw-border-grey-100 tw-px-4'>
        <div className='tw-flex tw-h-8 tw-items-center'>
          <div className='tw-flex-none'>
            <TrainingStatus
              currentTrainingStatus={currentTrainingStatus}
              isRequired={isRequired}
              requiredSource={requiredSource}
            />
          </div>
          <div
            className={classNames(
              'truncated-text-container truncated-text-container--auto',
              booking && 'tw-flex-auto',
            )}
          >
            <span className='tw-ml-2.5 tw-text-m tw-font-medium tw-text-grey-900'>
              {course.attributes.name}
            </span>
          </div>
          {booking && (
            <div className='tw-ml-2 tw-flex-none'>
              <TrainingRowBookingPill
                booking={booking}
                course={course}
                registration={registration}
              />
            </div>
          )}
          {!booking && attachments?.length > 0 && (
            <div
              className='tw-ml-2 tw-flex tw-h-6 tw-flex-none tw-items-center tw-rounded-md tw-border-1 tw-border-solid tw-border-grey-100 tw-px-1 tw-py-0.75'
              data-element-name='evidence-count'
            >
              <AttachmentIcon height={16} width={16} />
              <span className='tw-ml-1.5 tw-text-xs tw-font-semibold tw-tracking-wide'>
                {attachments.length}
              </span>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}

TrainingRow.propTypes = {
  course: resourceShape('course').isRequired,
  latestTraining: resourceShape('training'),
  attachments: PropTypes.arrayOf(resourceShape('attachment')),
  booking: resourceShape('booking'),
  registration: resourceShape('registration'),
  isRequired: PropTypes.bool,
  requiredSource: PropTypes.string,
  onViewCourseDetailsClick: PropTypes.func.isRequired,
};
